module.exports = __webpack_public_path__ + "img/intersect-circle.a5aa2b1a.svg";